
import React from 'react';
import ReactDOM from 'react-dom';
import swal from 'sweetalert';

class Promos extends React.Component
{
    constructor(props) {
        super(props);
        this.search = this.search.bind(this);
        this.renderItem = this.renderItem.bind(this);
        this.state = {
            promos: []
        };
    }

    componentWillMount()
    {
        let self = this;
        axios.get('api/promos/list/' + project)
            .then(response => {
                self.setState({
                    promos: response.data
                });
            })
            .catch(error => {
            });
    }

    componentDidMount()
    {
    }

    search()
    {
        let self = this;
        let search = $('#promosInputSearch').val();

        if (search.length === 0) {
            swal({
                title: "¡Oh no!",
                text: "No se ha escrito un criterio de búsqueda.",
                icon: "warning",
            });
        } else {
            axios.get('api/promos/search/' + project + '/' + search)
                .then(response => {
                    self.setState({
                        promos: response.data
                    });
                })
                .catch(error => {
                    swal({
                        title: "¡Oh no!",
                        text: "No se han obtenido resultados.",
                        icon: "warning",
                    });
                });
        }

    }

    renderItem(item)
    {
        let tc = item.no_codes === 1 ? item.no_codes + ' código asignable': item.no_codes + ' códigos asignables';

        return(
            <tr key={item.id}>
                <td>{item.name}</td>
                <td>{item.description}</td>
                <td>{tc}</td>
                <td>{item.created_at}</td>
                <td>
                    <a href={"/promos/edit/" + item.id} className={"btn btn-info waves-effect waves-light"}>
                        <i className="fa fa-search"></i> Editar
                    </a>
                </td>
            </tr>
        );
    }

    render()
    {
        return (
            <div>
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="panel panel-default">
                                <div className={"panel-header"}>
                                    <div className={"row"}>
                                        <div className="col-md-4 col-md-offset-4" style={{ paddingTop: "25px", paddingBottom: "25px" }}>
                                            <div className="col-md-8 col-md-offset-2">
                                                <img src="img/promos.png" className="img-responsive" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="panel-body">
                                    <div className="row">
                                        <div className="col-md-4">
                                            <label>Buscador</label>
                                            <div className="input-group m-t-10">
                                                <input type="text" id="promosInputSearch" className="form-control"/>
                                                <span className="input-group-btn">
                                                    <button type="button" className="btn waves-effect waves-light btn-primary" onClick={this.search}>
                                                        <i className={"fa fa-search"}></i> Buscar
                                                    </button>
                                                </span>
                                            </div>
                                        </div>
                                        <div className={"col-md-6"}></div>
                                        <div className="col-md-2">
                                            <div className="pull-right" style={{ marginTop: "35px" }}>
                                                <a href={'/promos/register'} className="form-control btn btn-success">
                                                    <i className={"fa fa-plus"}></i> Agregar
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                    {
                                        this.state.promos.length !== 0 &&
                                        <div className="row">
                                            <div className="col-md-12 p-20">
                                                <table className="table table-striped m-0">
                                                    <thead>
                                                    <tr>
                                                        <th>Nombre</th>
                                                        <th>Descripción</th>
                                                        <th>Códigos</th>
                                                        <th>Fecha de registro</th>
                                                        <th></th>
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    {this.state.promos.map(this.renderItem)}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Promos;

if (document.getElementById('promos-component')) {
    ReactDOM.render(<Promos />, document.getElementById('promos-component'));
}



// WEBPACK FOOTER //
// ./resources/assets/react/Promos.jsx